import {
  B000200Get,
  B010010GetShohin,
  B020010GetTanka,
  B020010GetWhTanka,
  B020010Kanosu,
  B020010Soko,
  catchRestError,
} from "clients/rest";
import { getSCode, KazeiKbn } from "messages/codes";
import { UseFormReturn } from "react-hook-form";
import {
  getJodaitanka,
  getJuchuKin,
  getJuchutanka,
  getKakeritsu,
  getUchizeiJuchutanka,
} from "services";
import {
  setshohinKbn,
  shohinshubetsuKbn,
  tankaKbn,
  uriagesakuseiKbn,
} from "services/codes";

// 固定値
// 内訳区分(返品)
const tankaKbnNormal = "0";
const whtankaKbnWh = "0";

// 商品変更メソッド(商品コード)
export const B020012HandleChangeShohinCd = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const meiFields = meiMethods.getValues();
  if (meiFields.shohinCd === "") {
    // 受注明細、紐づくセット構成品データの全項目をクリア
    HandleClearMeiByShohinCd(meiMethods);

    return;
  }
  // 商品名、janCd表示
  await B000200Get({ shohinCd: meiFields.shohinCd })
    .then((response) => {
      meiMethods.setValue("janCd", response.data.janCd ?? "");
      meiMethods.setValue("shohinNm", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      // 返却値が存在しない場合
      // 受注明細、紐づくセット構成品データの全項目をクリア
      HandleClearMeiByShohinCd(meiMethods);

      catchRestError(reason, navigate, setMsg);
    });
  // 商品関連項目設定処理
  await B020012Shohin(methods, meiMethods, navigate, setMsg);
};

// 明細クリア(商品コード変更時)
const HandleClearMeiByShohinCd = async (meiMethods: UseFormReturn) => {
  // 受注明細、紐づくセット構成品データの全項目をクリア
  const { shohinCd, meiTab } = meiMethods.getValues();
  // 明細、セット構成品をクリア(一部の値は保持しておく)
  meiMethods.reset();
  meiMethods.setValue("shohinCd", shohinCd);
  meiMethods.setValue("meiTab", meiTab);
};

//商品マスタ詳細情報取得処理メソッド(商品コード、JANコード入力)
export const B020012Shohin = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  const meiFields = meiMethods.getValues();
  if (meiFields.shohinCd === "") {
    meiMethods.setValue("vol", "");
    meiMethods.setValue("kazeiKbnView", "");
    meiMethods.setValue("kazeiKbn", "");
    meiMethods.setValue("tankaKbn", "");
    meiMethods.setValue("shohinshubetsuKbn", "");
    meiMethods.setValue("sotosunW", "");
    meiMethods.setValue("sotosunH", "");
    meiMethods.setValue("uchisunW", "");
    meiMethods.setValue("uchisunH", "");
    meiMethods.setValue("shokuchiKbn", "");
    meiMethods.setValue("kakeritsu", "");
    meiMethods.setValue("whtankaCd", "");
    meiMethods.setValue("zaikokanriKbn", "");
    return;
  }
  await B010010GetShohin({ shohinCd: meiFields.shohinCd })
    .then((response) => {
      meiMethods.setValue("vol", response.data.vol ?? "");
      meiMethods.setValue(
        "kazeiKbnView",
        getSCode(KazeiKbn, response.data.kazeiKbn.toString() ?? "")?.label
      );
      meiMethods.setValue("kazeiKbn", response.data.kazeiKbn ?? "");
      meiMethods.setValue("tankaKbn", response.data.tankaKbn ?? "");
      meiMethods.setValue("setshohinKbn", response.data.setshohinKbn ?? "");
      meiMethods.setValue(
        "shohinshubetsuKbn",
        response.data.shohinshubetsuKbn ?? ""
      );
      meiMethods.setValue("sotosunW", response.data.sotosunW ?? "");
      meiMethods.setValue("sotosunH", response.data.sotosunH ?? "");
      meiMethods.setValue("uchisunW", response.data.uchisunW ?? "");
      meiMethods.setValue("uchisunH", response.data.uchisunH ?? "");
      meiMethods.setValue("shokuchiKbn", response.data.shokuchiKbn ?? "");
      meiMethods.setValue("whtankaCd", response.data.whtankaCd ?? "");
      meiMethods.setValue("zaikokanriKbn", response.data.zaikokanriKbn ?? "");
      // 掛率には得意先.単価掛率を設定
      meiMethods.setValue("kakeritsu", fields.tankaKakeritsu);

      (async () => {
        // 倉庫取得処理
        await B020010Soko(
          fields.uriageSakuseiKbn,
          fields.uchiwakeKbn,
          meiMethods,
          navigate,
          setMsg
        );

        if (fields.uriageSakuseiKbn === uriagesakuseiKbn.new) {
          // 引当可能数取得処理
          await B020010Kanosu(methods, meiMethods, navigate, setMsg);
        }
      })();
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("vol", "");
      meiMethods.setValue("kazeiKbnView", "");
      meiMethods.setValue("kazeiKbn", "");
      meiMethods.setValue("tankaKbn", "");
      meiMethods.setValue("shohinshubetsuKbn", "");
      meiMethods.setValue("sotosunW", "");
      meiMethods.setValue("sotosunH", "");
      meiMethods.setValue("uchisunW", "");
      meiMethods.setValue("uchisunH", "");
      meiMethods.setValue("shokuchiKbn", "");
      meiMethods.setValue("kakeritsu", "");
      meiMethods.setValue("whtankaCd", "");
      meiMethods.setValue("zaikokanriKbn", "");
    });
  // セット商品以外の場合
  if (meiMethods.getValues().setshohinKbn === setshohinKbn.single) {
    // 単価区分「0:通常単価」の場合
    if (meiMethods.getValues().tankaKbn === tankaKbn.tujo) {
      // 単価取得処理
      await B020012Tanka(methods, meiMethods, navigate, setMsg);
    }
    // 単価区分「1:WH単価」の場合
    else if (meiMethods.getValues().tankaKbn === tankaKbn.wh) {
      // WH 単価取得処理
      await B020012WhTanka(methods, meiMethods, navigate, setMsg);
    }
  }
};

//商品マスタ詳細情報取得処理メソッド(在庫照会ダイアログからの選択)
export const B020012ShohinZaiko = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  const meiFields = meiMethods.getValues();
  if (meiFields.shohinCd === "") {
    meiMethods.setValue("vol", "");
    meiMethods.setValue("kazeiKbnView", "");
    meiMethods.setValue("kazeiKbn", "");
    meiMethods.setValue("tankaKbn", "");
    meiMethods.setValue("shohinshubetsuKbn", "");
    meiMethods.setValue("sotosunW", "");
    meiMethods.setValue("sotosunH", "");
    meiMethods.setValue("uchisunW", "");
    meiMethods.setValue("uchisunH", "");
    meiMethods.setValue("shokuchiKbn", "");
    meiMethods.setValue("kakeritsu", "");
    meiMethods.setValue("whtankaCd", "");
    meiMethods.setValue("zaikokanriKbn", "");
    return;
  }
  await B010010GetShohin({ shohinCd: meiFields.shohinCd })
    .then((response) => {
      meiMethods.setValue("vol", response.data.vol ?? "");
      meiMethods.setValue(
        "kazeiKbnView",
        getSCode(KazeiKbn, response.data.kazeiKbn.toString() ?? "")?.label
      );
      meiMethods.setValue("kazeiKbn", response.data.kazeiKbn ?? "");
      meiMethods.setValue("tankaKbn", response.data.tankaKbn ?? "");
      meiMethods.setValue("setshohinKbn", response.data.setshohinKbn ?? "");
      meiMethods.setValue(
        "shohinshubetsuKbn",
        response.data.shohinshubetsuKbn ?? ""
      );
      meiMethods.setValue("sotosunW", response.data.sotosunW ?? "");
      meiMethods.setValue("sotosunH", response.data.sotosunH ?? "");
      meiMethods.setValue("uchisunW", response.data.uchisunW ?? "");
      meiMethods.setValue("uchisunH", response.data.uchisunH ?? "");
      meiMethods.setValue("shokuchiKbn", response.data.shokuchiKbn ?? "");
      meiMethods.setValue("whtankaCd", response.data.whtankaCd ?? "");
      meiMethods.setValue("zaikokanriKbn", response.data.zaikokanriKbn ?? "");
      // 掛率には得意先.単価掛率を設定
      meiMethods.setValue("kakeritsu", fields.tankaKakeritsu);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("vol", "");
      meiMethods.setValue("kazeiKbnView", "");
      meiMethods.setValue("kazeiKbn", "");
      meiMethods.setValue("tankaKbn", "");
      meiMethods.setValue("shohinshubetsuKbn", "");
      meiMethods.setValue("sotosunW", "");
      meiMethods.setValue("sotosunH", "");
      meiMethods.setValue("uchisunW", "");
      meiMethods.setValue("uchisunH", "");
      meiMethods.setValue("shokuchiKbn", "");
      meiMethods.setValue("kakeritsu", "");
      meiMethods.setValue("whtankaCd", "");
      meiMethods.setValue("zaikokanriKbn", "");
    });
  // セット商品以外の場合
  if (meiMethods.getValues().setshohinKbn === setshohinKbn.single) {
    // 単価区分「0:通常単価」の場合
    if (meiMethods.getValues().tankaKbn === tankaKbn.tujo) {
      // 単価取得処理
      await B020012Tanka(methods, meiMethods, navigate, setMsg);
    }
    // 単価区分「1:WH単価」の場合
    else if (meiMethods.getValues().tankaKbn === tankaKbn.wh) {
      // WH 単価取得処理
      await B020012WhTanka(methods, meiMethods, navigate, setMsg);
    }
  }
};

//単価取得処理メソッド
export const B020012Tanka = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const fields = methods.getValues();
  const meiFields = meiMethods.getValues();

  await B020010GetTanka({
    tankaKbn: tankaKbnNormal,
    shohinCd: meiFields.shohinCd,
    tokuiCd: fields.tokuiCd,
    tokuishitenCd: fields.tokuishitenCd,
    kijunDate: fields.uriYmd,
  })
    .then((response) => {
      const jodaitanka = getJodaitanka(methods, response.data.jodaitanka ?? "");
      meiMethods.setValue("jodaitanka", jodaitanka ?? "");
      meiMethods.setValue("basejodaitanka", jodaitanka ?? "");
      meiMethods.setValue("aiteCd", response.data.aiteCd ?? "");

      // 取得した値を元に他項目を算出
      let kakeritsu: string;
      let uritanka: string;
      // 下代単価(売上単価)が取得できた場合(取引先別単価マスタ)
      if (response.data.juchutanka !== null) {
        // 下代単価(売上単価)
        uritanka = getUchizeiJuchutanka(methods, response.data.juchutanka);

        // 掛率(返却された受注単価 * 100 / 返却された上代単価) ※小数点以下切り捨て
        kakeritsu = getKakeritsu(uritanka, jodaitanka);
      }
      // 下代単価(受注単価)が取得できなかった場合(得意先マスタ.単価掛率)
      else {
        const fields = methods.getValues();
        // 掛率(得意先マスタ.単価掛率)
        kakeritsu = fields.tankaKakeritsu;
        // 下代単価(売上単価)
        uritanka = getJuchutanka(methods, jodaitanka, kakeritsu);
      }

      // 掛率
      meiMethods.setValue("kakeritsu", kakeritsu);
      // 下代単価(売上単価)
      meiMethods.setValue("uritanka", uritanka);
      meiMethods.setValue("baseuritanka", uritanka);
      // 売上金額
      meiMethods.setValue(
        "uriKin",
        getJuchuKin(
          uritanka,
          meiMethods.getValues().hitsuyosu,
          methods.getValues().kinmarumeKbn
        )
      );
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("jodaitanka", "");
      meiMethods.setValue("basejodaitanka", "");
      meiMethods.setValue("aiteCd", "");
      meiMethods.setValue("kakeritsu", "");
      meiMethods.setValue("uritanka", "");
      meiMethods.setValue("baseurianka", "");
      meiMethods.setValue("uriKin", "");
    });
};

//WH単価取得処理メソッド
export const B020012WhTanka = async (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = meiMethods.getValues();

  // 受注生産品ではない場合
  if (data.shohinshubetsuKbn !== shohinshubetsuKbn.madeToOrder) {
    // 何もしない
    return;
  }

  // 単価区分「0:通常」の場合
  if (data.tankaKbn === tankaKbn.tujo) {
    // 何もしない
    return;
  }

  // 入力済みではない場合
  if (data.whtankaCd === "" || data.sotosunH === "" || data.sotosunW === "") {
    // 何もしない
    return;
  }

  await B020010GetWhTanka({
    whtankaKbn: whtankaKbnWh,
    whtankaCd: data.whtankaCd,
    height: data.sotosunH,
    width: data.sotosunW,
  })
    .then((response) => {
      // 上代単価取得
      const jodaitanka = getJodaitanka(methods, response.data.tanka);
      // 上代単価
      meiMethods.setValue("jodaitanka", jodaitanka ?? "");
      meiMethods.setValue("basejodaitanka", jodaitanka ?? "");

      // 売上単価取得
      const uritanka: string = getJuchutanka(
        methods,
        jodaitanka,
        meiMethods.getValues().kakeritsu
      );

      // 下代単価(売上単価)
      meiMethods.setValue("uritanka", uritanka);
      meiMethods.setValue("baseuritanka", uritanka);
      // 売上金額
      meiMethods.setValue(
        "uriKin",
        getJuchuKin(
          uritanka,
          meiMethods.getValues().hitsuyosu,
          methods.getValues().kinmarumeKbn
        )
      );
    })
    .catch((reason) => {
      // WH単価取得の返却値が存在しない場合、ここに入る
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("jodaitanka", "");
      meiMethods.setValue("basejodaitanka", "");
      meiMethods.setValue("uritanka", "");
      meiMethods.setValue("baseuritanka", "");
      meiMethods.setValue("uriKin", "");
    });
  // 可能数取得
  await B020010Kanosu(methods, meiMethods, navigate, setMsg);
};
